// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__YpABs","label":"Labeled_label__lH-RP","divider":"Labeled_divider__3bAQu"};